import * as ActionTypes from './actionTypes'
//This library expects preexisting reducers to handle these actions

export const PrepareAccessKey = (stateLocation, accessKey) =>
{
    return {
        type: ActionTypes.SET_ACCESS_KEY,
        payload: {
            accessKey,
            stateLocation
        }
    }
};

export const PrepareUserMetadata = (stateLocation, userMetadata) =>
{
    return {
        type: ActionTypes.SET_USER_METADATA,
        payload: {
            userMetadata,
            stateLocation
        }
    }
};

export const PrepareLanguage = (stateLocation, language) =>
{
    return {
        type: ActionTypes.SET_LANGUAGE,
        payload: {
            language,
            stateLocation
        }
    }
};

export const SetIsProcessed = (stateLocation, message) => 
{
    return {
        type : ActionTypes.SET_IS_PROCESSED,
	    payload : {
	        id : message.id,
	        stateLocation
	    }
    }
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-postmessage/lib/actions/actions.js